import { useEffect } from 'react';
import type { RefObject } from 'react';
import { DOUBLE_CLICK_ZOOM_FACTOR, zoomAroundPoint } from '../core';
import { useStoreApi } from '../store';
import { isInsideClass, NO_PAN_CLASS, rendererPoint } from '../utils';

/** Double-click zooms in around the cursor; with Shift it zooms out (v11 `zoomOnDoubleClick`). */
export const useDoubleClickZoom = (rendererRef: RefObject<HTMLElement>): void => {
  const store = useStoreApi();
  useEffect(() => {
    const renderer = rendererRef.current;
    if (!renderer) return undefined;
    const handleDoubleClick = (event: MouseEvent) => {
      if (isInsideClass(event.target, NO_PAN_CLASS)) return;
      const { viewport, minZoom, maxZoom, setViewport } = store.getState();
      const factor = event.shiftKey ? 1 / DOUBLE_CLICK_ZOOM_FACTOR : DOUBLE_CLICK_ZOOM_FACTOR;
      setViewport(zoomAroundPoint(viewport, rendererPoint(renderer, event), viewport.zoom * factor, { minZoom, maxZoom }));
    };
    renderer.addEventListener('dblclick', handleDoubleClick);
    return () => renderer.removeEventListener('dblclick', handleDoubleClick);
  }, [rendererRef, store]);
};
